import { Component, inject } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { MessageService } from 'app/services'

@Component({
  selector: 'display-message',
  template: `@if (message(); as m) {<div class="display-message {{ m.style }}" [innerText]="m.text"></div>}`,
  imports: [],
  standalone: true
})
export class DisplayMessageComponent {
  message = toSignal(inject(MessageService).message$)
}
